import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import ContentWrapper from "../ContentWrapper";
import Block from "../Block";
import Column from "../Column";
import Form from "../Contact/Form";

const propTypes = {
    className: PropTypes.string,
    title: PropTypes.string.isRequired
};

const defaultProps = {
    className: undefined
};

export default function Contact({ className, title, sendMailTo }) {
    const titleClasses = classnames({
        "text-2xl  text-cobalt  font-normal  block": true
    });
    const item = classnames({
        "mb-8": true
    });

    return (
        <ContentWrapper className={className}>
            <Block>
                <Column className="w-full">
                    <h1 className="font-header  font-bold  text-6xl  text-sky  font-normal  mb-8">
                        {title}
                    </h1>
                </Column>
            </Block>
            <Block>
                <Column className="cms-content">
                    <div className={item}>
                        <span className={titleClasses}>Email</span>
                        <a
                            className="hover:text-sky"
                            href="mailto:info@superseton.com"
                        >
                            info@superseton.com
                        </a>
                    </div>

                    <div className={item}>
                        <span className={titleClasses}>Phone</span>
                        <span>
                            <a
                                className="no-underline  hover:text-sky"
                                href="tel:+31733035504"
                            >
                                +31 73 303 5504
                            </a>
                        </span>
                    </div>

                    <div className={item}>
                        <span className={titleClasses}>Address</span>
                        <div>
                                        SuperSeton BV
                                        <br />
                                        Paasheuvelweg 25 - Wing 5D
                                        <br />
                                        1105 BP Amsterdam
                                        <br />
                                        The Netherlands
                                    </div>
                    </div>
                </Column>

                <Column>
                    <Form  to={sendMailTo} />
                </Column>
            </Block>
        </ContentWrapper>
    );
}

Contact.propTypes = propTypes;
Contact.defaultProps = defaultProps;
